import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedCustomMessage.errors.";

const ticketChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const ticketChannelStepSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const ticketAutomationReceivedCaleExamGroupingSchema = z.object({
  id: z.string(),
  name: z.string(),
});
const ticketAutomationReceivedCustomMessageCalendarsSchema = z.object({
  id: z.string(),
  name: z.string(),
});
export const automationReceivedCustomMessageSchema = z
  .object({
    id: z.string().optional(),
    message: z.string().min(1, translationPath + "message"),
    ticketChannelStep: ticketChannelStepSchema.nullish(),
    ticketChannel: ticketChannelSchema.nullish(),
    ticketAutomationReceivedCaleExamGroupings: z
      .array(ticketAutomationReceivedCaleExamGroupingSchema)
      .nullish(),
    ticketAutomationReceivedCustomMessageCalendars: z
      .array(ticketAutomationReceivedCustomMessageCalendarsSchema)
      .nullish(),
  })
  .superRefine((val, ctx) => {
    if (val.ticketChannel) {
      if (!val.ticketChannelStep) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_step",
          path: ["ticketChannelStep"],
        });
      }
    }
  });

export type TAutomationReceivedCustomMessageForm = z.infer<
  typeof automationReceivedCustomMessageSchema
>;
